import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  // View actions
  registerChange: [
    'procedureId',
    'newModality',
    'newModalityName',
    'newPeriod',
    'newCampus',
    'plan',
    'career',
    'period',
    'shift',
    'shiftDesc'
  ],
  // Reducer
  registerChangeClear: null,
  registerChangeRequest: null,
  registerChangeSuccess: null,
  registerChangeFailure: ['error']
});

export { Creators, Types };
